import {
    getAttendeeTimezone,
    getEventDatesFormat,
    getFormattedEventDate as formatEventDate,
    shouldShowDateInAttendeeTimezone,
    TimezoneLocale,
} from '@eventbrite/event-date-time';
import { CheckoutState } from '../../state';
import { EventNamespace } from '../../state/event';
import { createSelector } from '../utils/selector';
import { getIsEventOnline } from './pureSelectors';

/**
 * Selector that can be used to retrieve the full event date range string to display
 */
export const getFormattedEventDate = createSelector(
    (state: CheckoutState) => state,
    (state: CheckoutState) => state.app.locale,
    ((state: CheckoutState, userLocale: string) => {
        // For online events we should show the attendee timezone
        const useTimezoneFrom = shouldShowDateInAttendeeTimezone({
            isOnlineEvent: getIsEventOnline(state),
            userTimezone: getAttendeeTimezone(),
        })
            ? TimezoneLocale.Attendee // Attendee for onLine events
            : TimezoneLocale.Creator; // Creator for onsite events

        const event = state.event as EventNamespace;

        return formatEventDate({
            event,
            locale: userLocale,
            datesFormat: getEventDatesFormat({
                event,
                locale: userLocale,
                useTimezoneFrom,
            }),
            useTimezoneFrom,
        });
    }) as unknown as any,
);
